const STEP_DAYS = { biweekly: 14, weekly: 7 };

function addMonthsClamped(iso, months) {
  const [y, m, d] = iso.split('-').map(Number);
  const target = new Date(Date.UTC(y, m - 1 + months, 1));
  const last = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
  target.setUTCDate(Math.min(d, last));
  return target.toISOString().slice(0, 10);
}

function addDaysIso(iso, n) {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function generateCheckSchedule({ count, firstCheckNumber, firstDate, cadence, totalCents, amountCents }) {
  const width = String(firstCheckNumber).length;
  const first = BigInt(firstCheckNumber);
  const even = Math.floor(totalCents / count);
  return Array.from({ length: count }, (_, i) => ({
    checkNumber: String(first + BigInt(i)).padStart(width, '0'),
    dueDate: cadence === 'monthly' ? addMonthsClamped(firstDate, i) : addDaysIso(firstDate, STEP_DAYS[cadence] * i),
    amountCents: amountCents ?? (i === count - 1 ? totalCents - even * (count - 1) : even),
  }));
}
